import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES, waLink } from "../data/content";

const ServiceCard = ({ s, big }) => (
  <a
    data-testid={`service-card-${s.id}`}
    href={waLink(`Olá, Gold Service! Gostaria de um orçamento para *${s.title}*.`)}
    target="_blank"
    rel="noopener noreferrer"
    className={`group relative overflow-hidden rounded-3xl gold-border-gradient bg-card transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_60px_-20px_rgba(212,175,55,0.35)] ${
      big ? "md:col-span-2 md:row-span-2 min-h-[320px] md:min-h-full" : "min-h-[220px]"
    } flex flex-col justify-end`}
  >
    <img
      src={s.image}
      alt={s.title}
      loading="lazy"
      className={`absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:scale-105 ${
        s.dim ? "opacity-20 group-hover:opacity-30" : "opacity-40 group-hover:opacity-55"
      }`}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
    <div className="relative p-5 sm:p-7">
      <span className="inline-block rounded-full border border-gold/40 bg-black/50 backdrop-blur px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-light">
        {s.badge}
      </span>
      <div className="mt-3 flex items-start justify-between gap-3">
        <div>
          <h3
            className={`font-display font-bold tracking-tight text-zinc-50 ${
              big ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"
            }`}
          >
            {s.title}
          </h3>
          <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-gold/90 font-medium">
            {s.subtitle}
          </p>
          <p className="mt-2 text-xs sm:text-sm leading-relaxed text-mist max-w-md">
            {s.description}
          </p>
        </div>
        <span className="shrink-0 mt-1 inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-zinc-300 transition-all duration-500 group-hover:bg-gold group-hover:text-ink group-hover:border-gold group-hover:rotate-45">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </div>
  </a>
);

export const Services = () => (
  <section id="servicos" className="relative py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Overline>Nossos serviços</Overline>
        <div className="mt-4 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-xl text-balance">
            Soluções completas para sua <span className="gold-text">casa ou empresa</span>
          </h2>
          <p className="text-sm text-mist max-w-sm">
            Toque em um serviço e fale direto com a gente no WhatsApp. Sem
            compromisso, sem enrolação.
          </p>
        </div>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={Math.min(i * 0.08, 0.4)} className={i === 0 ? "md:col-span-2 md:row-span-2" : ""}>
            <ServiceCard s={s} big={i === 0} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
